<template>
  <div class="left cadfm-flexitem-fixed" v-if="partId">
    <action-panel>
      <action-bar>
        <b-navbar-nav>

          <action-button  @click="toggleLeftPanel"  icon="hide" bold text="Hide" title="Hide panel" :disabled="false"/>



        </b-navbar-nav>
      </action-bar>
      <action-content>
        <div class="Tabs">
         <b-tabs card>

            <b-tab :title="lang.Content.tab_Revisions"  :title-link-class="textColors" :title-item-class="textColors" active >
              <p>{{lang.Content.infotext_1}}: {{selectedLibrary}}<br>
              {{ lang.Content.infotext_2 }}: {{ libraryCategory }}</p>
              <RevisionTableComponent :lang="lang.Content.RevisionsTable"></RevisionTableComponent>
            </b-tab>
            

          </b-tabs>

        </div>
      </action-content>
    </action-panel>

 </div>
</template>


<script>

//import Right from '@/components/PartManager/Right/Right'
import { mapGetters } from 'vuex'
import ActionBar from '@/components/shared/ActionBar'
import ActionButton from '@/components/shared/ActionButton'
import ActionContent from '@/components/shared/ActionContent'
import ActionPanel from '@/components/shared/ActionPanel'
import RevisionTableComponent from '@/components/shared/RevisionTableComponent'
//import RevisionDiagramComponent from '@/components/shared/RevisionDiagramComponent'

export default {
  name: 'Left',
  components:{
    ActionBar,
    ActionButton,
    ActionContent,
    ActionPanel,

    RevisionTableComponent,
    //RevisionDiagramComponent
  },
  props:{
    lang: Object
  },
  data () {
    return {
      name: "LeftContentLibraryDetails",
      partId: true,
      detailsButtonStatus: false,
      libraryCategory: "",
      ln: ""
    }
  },
  computed: {
    ...mapGetters({

      revisionHistory: 'revisionHistory',
      selectedRows: 'selectedRows'
    }),
    selectedLibrary(){
      let ln = this.ln;  
      // for (let prop in this.$store.getters.selectedRows[0]){
        
      //   if (this.$store.getters.selectedRows[0][prop].type == "library number"){
      //     ln = this.$store.getters.selectedRows[0][prop].value.display;
      //     break;
      //   }
      // }    

      return ln;
    },
    isData(){
      return Object.keys(this.$store.getters.revisionHistory).length != 0
      //return this.$store.getters.revisionHistory.length != 0
    },
    textColors(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return ['tabs-bg-dark', 'tabs-text-light']
      }else{
        return ['tabs-bg-light', 'tabs-text-dark']
      }

    },
    lastRevisionHistory() {

      let tab = this.$store.getters.revisionHistory;
      let obj = tab[0];
      for (let i = 0, lei = tab.length; i < lei; i++) {

        if (tab[i].revision > obj.revision) {
          obj = tab[i];
        }
      }

      return obj;
    },
    reloadedAfterAction() {
      return this.$store.getters.reloadedAfterActionComplex;
    }
  },

  created() {

    if (this.$store.getters.selectedRows.length > 0){

      this.getDetails();
    }

  },
  watch: {
    selectedRows: function (newVal) {
      
      if (this.$store.getters.selectedRows.length > 0){

        this.getDetails();
      }
    },
    lastRevisionHistory: function () {

      this.loadDataForRevisions();

    },
    reloadedAfterAction: {
      handler: function (newValue) {

        for (let el in newValue) {
          if (newValue[el].name == this.name) {
            if (newValue[el].status == true) {

              this.getDetails();

              newValue[el].status = false;

              this.$store.dispatch("reloadAfterActionComplex", newValue[el]);
            }
          }
        }
      },
      deep: true

    },
  },
  updated() {
        

  },
  methods: {
    loadDataForRevisions() {

      let vue = this;

      let obj = {
        revisionId: this.$route.query.revisionId,

      }

      this.$store.dispatch(this.$store.getters.sectionPrefix + "_getLibrary", obj)
        .then(function (result) {
          console.log(result)

          if (result.status == "OK") {
            if (result.data != null) {
              for (let i = 0, lei = result.data.length; i < lei; i++) {
                if (result.data[i].type == "library number") {
                  vue.ln = result.data[i].value.display;
                }
              }
            }
          } else {

          }



        })



    },
    getDetails() {

      let vue = this;

      let value = this.$store.getters.selectedRows[0].col___revisionId.libraryId;

      this.$store.dispatch(this.$store.getters.sectionPrefix + '_getRevisionHistory', value);

      let obj = {
        revisionId: this.$store.getters.selectedRows[0].col___revisionId.revisionId
      }

      this.$store.dispatch(this.$store.getters.sectionPrefix + '_getCategoryByRevisionId', obj)
        .then((result) => {

          console.log(result)

          if (result.status == "OK") {

            let pos = result.data[0].categoryPath.indexOf("\\");

            let len = result.data[0].categoryPath.length;
            let str = result.data[0].categoryPath.substr(pos + 1, len);

            vue.libraryCategory = str;

          }

        })
    },
    toggleLeftPanel(){

      this.$parent.isVisibleLeft = !this.$parent.isVisibleLeft;

    }
  }
}
</script>


<style scoped>
.left{
  border-right: 1px solid #666;
  min-width: 400px;
}

.center-content{
  text-align: center;
}
img {
  max-width:200px;
  max-height:200px;
}
</style>



// WEBPACK FOOTER //
// src/components/LibraryManager/Views/LibraryDetails/Left/Left.vue